import type { PrintContext } from '@ahd/shared/types/ahd-cars-print/context';
import sVorinformation from '../_json/s_settingsVorinformation';
import axios from './Axios';
import { getAxiosHeader } from './AxiosVars';
import { getIdUser, getMitarbeiter4Id, getPrintFirma } from './Session';
import { type NetworkProgress, checkUndefinedNullOrEmpty, isDevBeta, isLocalServer, networkHandler } from './Tools';

export function getPrint(
    id: PrintContext['id'],
    cars: PrintContext['cars'],
    params: PrintContext['params'],
    downloadProgressFunc: (progressEvent: NetworkProgress) => void,
    signal: AbortController['signal']
) {
    const url = isLocalServer() ? `http://${location.hostname}:61300/getPrint` : isDevBeta() ? 'https://print-dev.autohaus-digital.de/getPrint' : 'https://print.autohaus-digital.de/getPrint';

    const printFirma = getPrintFirma();
    const printContext: Pick<PrintContext, 'cars' | 'firma' | 'id' | 'params' | 'user'> = {
        cars: !checkUndefinedNullOrEmpty(cars) ? cars : undefined,
        firma: {
            ...printFirma,
            c: {
                ...printFirma?.c,
                srr: !checkUndefinedNullOrEmpty(cars) ? sVorinformation(cars?.[0], printFirma?.i) : undefined,
            },
        },
        id: id,
        params,
        user: getMitarbeiter4Id(getIdUser()),
    };

    return axios({
        title: 'Abrufen der Druckvorlage',
        method: 'post',
        url: url,
        data: printContext,
        responseType: params?.showHtml ? undefined : 'blob',
        headers: getAxiosHeader(),
        onDownloadProgress: (progressEvent) => networkHandler(progressEvent, downloadProgressFunc),
        signal: signal,
        noToast: true,
        timeout: 0,
    });
}
